import type { FC } from 'react';

import { useCallback } from 'react';

import { useIsOldPointshopItemsDisabled } from '../../../common/hooks/bonus2026FeatureFlagHooks';
import { useAppSelector } from '../../../common/hooks/useThunkDispatch';
import { storeSelectors } from '../../../common/selectors/storeSelectors';
import { SearchStateProvider } from '../../../search/contexts/searchStateContext';
import { globalSearchAbortable } from '../../../search/hooks/useGlobalSearchState';
import { SearchFromPageType } from '../../models/SearchFromPageType';

interface GlobalSearchStateProviderProps {
    initialQuery: string;
    searchFromPage: SearchFromPageType;
}

const GlobalSearchContext: FC<React.PropsWithChildren<GlobalSearchStateProviderProps>> = ({
    searchFromPage,
    initialQuery,
    children,
}) => {
    const currentProductionUnit = useAppSelector(storeSelectors.currentProductionUnit);
    const isOldPointshopItemsDisabled = useIsOldPointshopItemsDisabled();

    const globalSearchFunction = useCallback(
        async (_abortSignal: AbortSignal, _query: string) =>
            globalSearchAbortable({
                query: _query,
                currentProductionUnit,
                resultCountsPerPage: {
                    articles: 4,
                    products: 4,
                    stores: 4,
                    recipes: searchFromPage === SearchFromPageType.Recipes ? 10 : 5,
                    pointshop: 6,
                },
                quickSearch: true,
                abortSignal: _abortSignal,
                excludePointShopItems: isOldPointshopItemsDisabled,
            }),
        [currentProductionUnit, searchFromPage, isOldPointshopItemsDisabled],
    );

    return (
        <SearchStateProvider
            initialQuery={initialQuery}
            searchFunction={globalSearchFunction}
            searchFromPage={searchFromPage}
            minimumQueryLength={3}
            initialSearchType="direct"
        >
            {children}
        </SearchStateProvider>
    );
};

export default GlobalSearchContext;
